class SubscriptionPage implements ng.IComponentController {
    constructor() {
    }
}

angular.module('animatronApp.SubscriptionPage', [])
    .component('subscriptionPage2', {
        controller: SubscriptionPage,
        templateUrl: require('settings/subscription/subscription-page.html')
    });



// WEBPACK FOOTER //
// ./app/assets/javascripts/settings/subscription/SubscriptionPage.ts